import { NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class SignUpService {
    constructor(ngZone) {
        this.ngZone = ngZone;
        this.signUpChanged = new BehaviorSubject(null);
    }
    show() {
        this.signUpChanged.next(true);
    }
    hide() {
        this.signUpChanged.next(false);
    }
}
SignUpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SignUpService_Factory() { return new SignUpService(i0.ɵɵinject(i0.NgZone)); }, token: SignUpService, providedIn: "root" });
